import React, { useEffect, useState } from "react";
import upload from "../../Assets/svg/upload-icon.svg";
import tooltip from "../../Assets/tooltip-icon.png";
import Input from "./Input";
import plus from "../../Assets/svg/upload plus new.svg";
import pdf from "../../Assets/svg/pdf-logo.svg";
import cross from "../../Assets/svg/cross.svg";
function DocUpload(props) {
  const [tool, showTool] = useState(false);
  const [file, setFile] = useState(props.value);
  // console.log("pdf", props.value);
  return (
    <div className="doc-upload-section">
      <div className="sub-title ">
        {props.title}
        {!props.noTooltip && (
          <img
            src={tooltip}
            alt="tool tip"
            onMouseLeave={() => showTool(false)}
            onMouseOver={() => showTool(true)}
          />
        )}
        {/* {props.showErr && <div className="warning-msg">Required</div>}{" "} */}
        {tool && props.tooltipContent}
      </div>
      <div className="doc-upload">
        {!props.value && (
          <input
            type="file"
            accept=".pdf"
            onChange={(e) => props.onChange(e.target.files[0])}
          />
        )}
          <div className="doc-left">
            <div className="icon">
              <img src={!props.value ? upload : pdf} alt="upload" />

              <div className="upload-text">
                <div className="upload-top-text">
                  {props.value
                    ? props.value.name
                    : props.placeholder
                    ? props.placeholder
                    : " Upload Verification Document"}
                </div>
                <div className="text-one">
                  {props.value ? (
                    <span style={{textAlign:'left'}}>{(props.value.size / 1024).toFixed(2)} KB</span>
                  ) : (
                    <>
                      Max: <span>2 Mb</span>
                    </>
                  )}
                </div>
                <div className="text-one" 
                style={{ textAlign:'left' }}
                >
                  Supported formats: Word Doc, PDF, JPEG, PNG
                </div>
              </div>
            </div>
          </div>
          <div
            className={`plus-icon pointer ${props.isLoader && "is-loader"}`}
            onClick={() => props.value && props.onChange(null)}
          >
            <img
              src={props.value ? cross : plus}
              alt="plus"
              style={{ height: "38%" }}
            />
          </div>
      </div>
      {/* {tool && ( */}

      {/* )} */}
      {props.footerText && <div className="text-one">{props.footerText}</div>}
    </div>
  );
}

export default DocUpload;
